import { FormControl, MenuItem, Select, Typography, Box } from '@mui/material';

export const BranchSelector = ({ branches, selectedBranch, onChange }) => (
  <Box sx={{ marginBottom: '20px' }}>
    <Typography
      variant="body2"
      sx={{
        marginBottom: '8px',
        color: '#333',
        fontWeight: 500,
        fontSize: '14px',
      }}
    >
      Sucursal
    </Typography>
    <FormControl variant="outlined" fullWidth>
      <Select
        value={selectedBranch?.id || selectedBranch?.uuid || selectedBranch?.uuid_branch || ''}
        onChange={onChange}
        displayEmpty
        sx={{
          backgroundColor: '#fafafa',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#999',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#5e894f',
          },
          '& .MuiSelect-select': {
            padding: '12px 14px',
            fontSize: '14px',
          },
        }}
      >
        <MenuItem value="" disabled>
          Seleccione una sucursal
        </MenuItem>
        {branches.map((branch) => (
          <MenuItem
            key={branch.id || branch.uuid || branch.uuid_branch}
            value={branch.id || branch.uuid || branch.uuid_branch}
          >
            {branch.description || branch.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
);
